<template>
    <div class="banner-container">
        <img
            v-show="currentGame === item.slug"
            v-for="(item, index) in bannerImages"
            :src="renderBannerSrc(item)"
            :key="index"
        />
    </div>
</template>
<script>
export default {
    props: {
        bannerImages: {
            type: Array,
            default: () => [],
        },
        currentGame: {
            type: String,
        },
    },
    methods: {
        renderBannerSrc(item) {
            if (this.$store.state.isScreenMobile && item.bannerMobile) {
                return item.bannerMobile;
            }
            return item.banner;
        },
    },
}
</script>


<style lang="scss" scoped>
@import "@/public/scss/common/header/banner.scss";
</style>
